import { toast } from "react-toastify";

export const CustomToast = (type, message) => {
  switch (type.toUpperCase()) {
    case "SUCCESS":
      return toast.success(message);
    case "INFO":
      return toast.info(message);
    case "WARN":
      return toast.warn(message);
    case "ERROR":
      return toast.error(message);
    default:
      break;
  }
};
